import { render, staticRenderFns } from "./CreateSpokespersonModal.vue?vue&type=template&id=eb674d5e&"
import script from "./CreateSpokespersonModal.vue?vue&type=script&lang=js&"
export * from "./CreateSpokespersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports